"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CapitalOneCafeLined = function CapitalOneCafeLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 11V9.5a.5.5 0 00-.5-.5h-14a.5.5 0 00-.5.5v6A5.506 5.506 0 008.5 21h4a5.506 5.506 0 005.287-4H18a3 3 0 100-6zm-1 4.5a4.505 4.505 0 01-4.5 4.5h-4A4.505 4.505 0 014 15.5V10h13zm1 .5h-.025c.015-.165.025-.331.025-.5V12a2 2 0 110 4zm-7.946 1.25A7.823 7.823 0 018 18v-.7a7.85 7.85 0 001.921-1.36 1.924 1.924 0 00.6-1.32 1.108 1.108 0 00-.688-.93A5.2 5.2 0 008 13.14v-1.06c.2-.026.49-.046.86-.06S9.592 12 9.949 12a9.869 9.869 0 013.067.35q.984.35.984 1.01a2.132 2.132 0 01-.564 1.25 8.658 8.658 0 01-1.442 1.4 12.264 12.264 0 01-1.94 1.24zm-4.91-12.1c.49-.5.638-.647-.01-1.295a.5.5 0 01.707-.708c1.351 1.352.482 2.232.015 2.705-.49.5-.638.647.01 1.3a.5.5 0 01-.707.708c-1.351-1.36-.482-2.238-.015-2.711zm5 0c.49-.5.638-.647-.01-1.295a.5.5 0 01.707-.708c1.351 1.352.482 2.232.015 2.705-.49.5-.638.647.01 1.3a.5.5 0 01-.707.708c-1.351-1.36-.482-2.238-.015-2.711zm5 0c.49-.5.638-.647-.01-1.295a.5.5 0 01.707-.708c1.351 1.352.482 2.232.015 2.705-.49.5-.638.647.01 1.3a.5.5 0 01-.707.708c-1.351-1.36-.482-2.238-.015-2.711z",
    fill: "currentColor"
  })));
};

var _default = CapitalOneCafeLined;
exports["default"] = _default;